import { render, staticRenderFns } from "./NovaIcon.vue?vue&type=template&id=219eaac2&lang=pug&"
import script from "./NovaIcon.vue?vue&type=script&lang=js&"
export * from "./NovaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports